import {
  FETCH_MOBILE_APPS_LIST,
  FETCH_MOBILE_APPS_LIST_ERROR,
  SET_MOBILE_APPS_LIST,
  LOG_OUT,
} from '../constants';

import { GroupTheBoundaries } from '../../utilities/report-helpers';

const initialState = {
  mobileAppsListLoaded: false,
  mobileAppsList: [],
};

const mobileAppsList = (state = initialState, action) => {
  switch (action.type) {
    case LOG_OUT:
      return {
        ...initialState,
      };
    case FETCH_MOBILE_APPS_LIST:
      return {
        ...state,
        mobileAppsListLoaded: false,
      };
    case FETCH_MOBILE_APPS_LIST_ERROR:
      return {
        ...state,
        mobileAppsListLoaded: false,
      };
    case SET_MOBILE_APPS_LIST:
      return {
        ...state,
        mobileAppsListLoaded: true,
        mobileAppsList : GroupTheBoundaries(action.data,'mobileAppsList')
      };
    default:
      return state;
  }
};

export default mobileAppsList;
